import BadRequestError from 'util/api/errors/BadRequestError';

export default class BadRequestFormError extends BadRequestError {
    constructor(response, validationsBackend) {
        super(response);

        this.validationsBackend = validationsBackend;
    }
}



// WEBPACK FOOTER //
// ./src/util/api/errors/BadRequestFormError.js